import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRunning } from "@fortawesome/free-solid-svg-icons";
import "./RunningIcon.css";

const RunningIcon = ({ isActive }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="running-icon-container"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {!isHovered && !isActive ? (
        <FontAwesomeIcon icon={faRunning} style={{ color: "#FDFEFE" }} />
      ) : (
        <div className="running">
          <div className="outer">
            <div className="body">
              <div className="arm behind"></div>
              <div className="arm front"></div>
              <div className="leg behind"></div>
              <div className="leg front"></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RunningIcon;
